// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"63d36c29","583":"0508c1b6","983":"2b67b323"}[chunkId] + ".chunk.js";
};